import * as URL from "../helpers/Constants";
import axios from "axios";

export default class PharmacyGenericAdminService {
    static getAllForAdmin(page, size, id, genericName) {
        return axios.get(URL.GET_ALL_PHARMACY_GENERICS_FOR_ADMIN, {
            ...PharmacyGenericAdminService.getAuthHeader(),
            params: {page, size, id, genericName}
        });
    }

    static getGenericForAdmin(id) {
        return axios.get(`${URL.GET_PHARMACY_GENERIC_FOR_ADMIN_BY_ID}/${id}`, PharmacyGenericAdminService.getAuthHeader());
    }

    static savePharmacyGenericForAdmin(data) {
        return axios.post(URL.POST_PHARMACY_GENERIC_FOR_ADMIN, data, PharmacyGenericAdminService.getAuthHeader());
    }

    static updatePharmacyGenericForAdmin(data, id) {
        if(id === "" || id === null) {
            id = 0;
        }
        return axios.put(`${URL.UPDATE_PHARMACY_GENERIC_FOR_ADMIN}/${id}`, data, PharmacyGenericAdminService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {headers: {"Authorization": `Bearer ${accessToken}`}};
    }
}
